/**
 * loại chứng từ
 */
export default {
  /* -----------------------------------------------------
  Cấu hình RefType load service cho button print Bamboo
   ------------------------------------------------------ */

  // Không phải chứng từ
  NonVoucher: 0,
  // Phiếu thu
  CAReceipt: 20,
  // Phiếu chi
  CAPayment: 21,
  // Bảng kiểm kê quỹ tiền mặt
  CAFundInventory: 22,
  // Nộp tiền Kho bạc
  BADeposit: 30,
  // Rút tiền Kho bạc
  BUTreasuryWithdrawal: 31,
  // Chuyển tiền nội bộ
  BAInternalTransfer: 32,
  // Chi tiền gửi
  BAWithDraw: 33,
  // Bảng kê nộp NSNN
  BAAdvanceNSNN: 35,
  // Chuyển khoản kho bạc
  BUTransfer: 34,
  // Điều chỉnh kinh phí chi
  CAAdjustPayment: 40,
  // Điều chỉnh kinh phí thu
  CAAdjustReceipt: 41,
  // Đề nghị cam kết chi *
  BUCommitmentRequest: 42,
  // Điều chỉnh cam kết chi *
  BUPlanAdjustCommit: 43,
  // Dự toán giữ lại
  BUBudgetReserve: 44,
  // Nhập khác
  INInward: 60,
  // Phiếu xuất kho
  INOutward: 61,
  // Nhập mua bằng tiền mặt
  InventoryInwardCash: 62,
  // Nhập mua bằng tiền gửi
  InventoryInwardDeposit: 63,
  // Chuyển kho
  InventoryTransfer: 64,
  // Số dư ban đầu vật tư
  OpeningInventoryItem: 69,
  // Phiếu ghi tăng TSCĐ
  FixedAssetIncrement: 70,
  // Phiếu ghi giảm TSCĐ
  FixedAssetDecrement: 71,
  // Phiếu điều chỉnh TSCĐ
  FixedAssetAdjustment: 72,
  // Khấu hao TSCĐ
  FixedAssetDepreciation: 73,
  // Phiếu ghi tăng CCDC
  ToolIncrement: 74,
  // Phiếu ghi giảm CCDC
  ToolDecrement: 75,
  // Phiếu điều chuyển CCDC
  ToolTransfer: 77,
  // Điều chuyển phòng ban
  FixedAssetTransfer: 76,
  // Số dư ban đầu TSCĐ
  OpeningFixedAsset: 78,
  // Số dư ban đầu CCDC
  OpeningTool: 79,
  // Bảng lương
  SalarySheet: 80,
  // Hạch toán chi phí lương
  GlPayrollExpense: 81,
  // Chứng từ nghiệp vụ khác
  SUGeneralVoucher: 100,
  // Phiếu kết chuyển tài khoản
  SUAccountTransfer: 101,
  // Tổng hợp chứng từ cùng loại
  SUVoucherList: 102,
  // Bảng kê ghi thu - ghi chi
  BUExpenseReceipt: 103,
  // Bảng kê thanh toán tạm ứng
  BUAdvancePayment: 104,
  // Bảng kê chứng từ thực chi
  BUAdvanceExpence: 105,
  // Chứng từ ghi đồng thời
  ParallelVoucher: 106,
  // Số dư đầu tài khoản khác
  OpeningAccount: 109,
  // Số dư đầu mục lục ngân sách
  OpeningBudget: 110,
  // Số dư ban đầu đối tượng
  OpeningAccountingObject: 112,
  // Số dư ban đầu quỹ
  OpeningFund: 113,
  // Số dư ban đầu Hoạt động tài chính
  OpeningActivity: 114,
  // Số dư ban đầu Hoạt động tài chính và Đối tượng
  OpeningActivityAndAccountingObject: 115,
  // Số dư ban đầu tài khoản ngân hàng
  OpeningBankAccount: 116,
  // Số dư ban đầu MLNS và tài khoản ngân hàng
  OpeningBudgetAndBankAccount: 117,
  // Số dư ban đầu Quỹ và tài khoản ngân hàng
  OpeningFundAndBankAccount: 118,
  // Chứng từ ghi sổ
  RegisterVoucher: 120,
  // Bảng tổng hợp biên lai thu tiền
  EReceiptSummary: 122,
  // Kết chuyển chênh lệch thu, chi ngân sách xã
  TranferReceiptClear: 130,
  // Kết chuyển chi ngân sách
  TranferPaymentClear: 131,
  // Kết chuyển cuối năm
  TranferClosing: 132,
  // Kết chuyển kết dư sang thu ngân sách xã
  TransferBudgetBalance: 133,
  // Kết chuyển hoạt động sự nghiệp
  TransferActivity: 134,
  // Quyết toán dự toán chi ngân sách cuối năm
  TransferBegining: 135,
  // Kết chuyển chênh lệch thu, chi ngân sách trong thời gian chỉnh lý
  TranferReceiptClearInMonth13: 136,
  // Kết chuyển chi ngân sách trong thời gian chỉnh lý
  TranferPaymentClearInMonth13: 137,
  // Kết chuyển kết dư ngân sách xã
  TransferBalance: 138,
  // Kết chuyển kết dư ngân sách xã trong thời gian chỉnh lý
  TransferBalanceInMonth13: 139,
  // Dự toán chi theo MLNS
  BUPlanExpenseByBudget: 150,
  // Bổ sung Dự toán chi theo MLNS
  BUPlanExpenseByBudgetSupplement: 151,
  // Điều chỉnh Dự toán chi theo MLNS
  BUPlanExpenseByBudgetSupplementAdjust: 320,
  // Dự toán chi theo TT 342
  BUPlanExpenseByActivity342: 322,
  // Bổ sung Dự toán chi theo TT 342
  BUPlanExpenseByActivitySupplement342: 323,
  // Điều chỉnh Dự toán chi theo TT 342
  BUPlanExpenseByActivitySupplementAdjust342: 324,
  // Dự toán chi theo TT343
  BUPlanExpenseByActivity343: 325,
  // Bổ sung Dự toán chi theo TT343
  BUPlanExpenseByActivitySupplement343: 326,
  // Điều chỉnh Dự toán chi theo TT343
  BUPlanExpenseByActivitySupplementAdjust343: 327,
  // Dự toán chi theo TT344
  BUPlanExpenseByActivity344: 328,
  // Dự toán chi theo Vũ Thư
  BUPlanExpenseByActivityVt: 340,
  // Bổ sung Dự toán chi theo TT344
  BUPlanExpenseByActivitySupplement344: 329,
  //Bổ sung dự toán chi theo Vũ Thư
  BUPlanExpenseByActivitySupplementVt: 341,
  // Điều chỉnh Dự toán chi theo TT344
  BUPlanExpenseByActivitySupplementAdjust344: 330,
  // Điều chỉnh Dự toán chi theo Vũ Thư
  BUPlanExpenseByActivitySupplementAdjustVt: 342,
  // Bổ sung Dự toán chi theo TT344
  BUPlanExpenseByActivitySupplement344: 329,
  //Bổ sung dự toán chi theo Vũ Thư
  BUPlanExpenseByActivitySupplementVt: 341,
  // Điều chỉnh Dự toán chi theo TT344
  BUPlanExpenseByActivitySupplementAdjust344: 330,
  // Điều chỉnh Dự toán chi theo Vũ Thư
  BUPlanExpenseByActivitySupplementAdjustVt: 342,
  // Dự toán thu theo MLNS
  BUPlanReceiptAddMLNS: 152,
  // Bổ sung Dự toán thu theo MLNS
  BUPlanReceiptAddMLNSSupplement: 153,
  // Điều chỉnh Dự toán thu theo MLNS
  BUPlanReceiptAdjustMLNS: 321,
  // Dự toán thu theo TT 342
  BUPlanReceiptAddTT342: 331,
  // Bổ sung Dự toán thu theo TT 342
  BUPlanReceiptSupplementTT342: 332,
  // Điều chỉnh Dự toán thu theo TT 342
  BUPlanReceiptAdjustTT342: 333,
  // Dự toán thu theo TT343
  BUPlanReceiptAddTT343: 334,
  // Bổ sung Dự toán thu theo TT343
  BUPlanReceiptSupplementTT343: 335,
  // Điều chỉnh Dự toán thu theo TT343
  BUPlanReceiptAdjustTT343: 336,
  // Dự toán thu theo TT344
  BUPlanReceiptAddTT344: 337,
  // Bổ sung Dự toán thu theo TT344
  BUPlanReceiptSupplementTT344: 338,
  // Điều chỉnh Dự toán thu theo TT344
  BUPlanReceiptAdjustTT344: 339,
  // Nhận dự toán đầu năm
  BUReceiveBudgetPlan: 154,
  // Nhận dự toán bổ sung
  BUReceiveBudgetPlanSupplement: 155,
  // Điều chỉnh dự toán
  BUPlanAdjustment: 156,
  // Hủy dự toán
  BUPlanCancel: 157,
  // Chi tiền gửi trả lương
  CashPaymentDepositSalary: 163,
  // Phiếu chi trả lương
  CashPaymentSalary: 164,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDeposit: 165,
  // Kế hoạch vốn đầu tư xây dựng cơ bản
  ConstructionBudget: 303,
  // Kế hoạch thu chi các hoạt động tài chính khác
  BUFinancialActivities: 304,
  // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherIncreament: 410,
  // Điều chỉnh TSCĐ từ QLTS.VN
  FAVoucherAdjustment: 411,
  // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDepreciate: 412,
  // Hao mòn TSCĐ từ QLTS.VN
  FAVoucherDepreciation: 413,
  // Ghi giảm TSCĐ từ QLTS.VN
  FAVoucherDecrement: 414,
  // Điều chỉnh kinh phí
  BUExpenseWithdrawAdjustment: 652,
  // Biên lai điện tử
  ElectricReceipt: 701,
  // Chứng từ trả lương, bảo hiểm
  SalaryVoucher: 123,
  // SalaryVoucherTreasury: 124,
  // Chi tiết hóa đơn
  InbotInvoiceDetail: 666,
  // Chi tiết hồ sơ
  DVCFileDetail: 667,
  // Hóa đơn công nợ
  DebtInvoice: 669,

  /* //TODO Ở danh mục/ Định khoản tự động có dùng đến enum RefType này
  Khi thêm 1 giá trị cho enum vui lòng xem xét ở Định khoản tự động có dùng không
  + Có dùng thì thêm cả tên của giá trị ở i18nEnum.RefType 
  + Không dùng thì thêm giá trị mới này vào AutoBusinessDetail.vue / ms-combobox-enum (enum="RefType")/ignoreKeys
  và autoBusinessList.js / customColumns /c.ignoreKeys
  */
};
